import React from "react";
import { exact, number, string } from "prop-types";
import { percentageLevels } from "utils/indicator/indicatorSettings";
import styles from "./RegionLoadingRow.module.styl";
import Chart from "react-apexcharts";
import { Link } from "react-router-dom";
import { chartOptions, smallChartWidth } from "utils/chart/chartOptions";

export default function RegionLoadingRow({ regionId, regionLoading }) {
    const indicatorStyle = percentageLevels.indicatorColor(regionLoading.loading);
    const options = chartOptions(indicatorStyle);
    const series = [regionLoading.loading];

    return (
        <div className={styles.row}>
            <Link
                to={`/loading/region/${regionId}/municipality/${regionLoading.municipalityId}`}
                className={styles.municipalityName}
            >
                {regionLoading.municipalityName}
            </Link>
            <div className={styles.sportObjectsCount}>{regionLoading.sportObjectsCount}</div>
            <div className={styles.chart}>
                <Chart options={options} series={series} type="radialBar" width={smallChartWidth} />
            </div>
        </div>
    );
}

RegionLoadingRow.propTypes = {
    regionId: number.isRequired,
    regionLoading: exact({
        municipalityId: number,
        municipalityName: string,
        loading: number,
        sportObjectsCount: number,
    }),
};
